import { render, staticRenderFns } from "./ElderResidentsByNursingLevel.vue?vue&type=template&id=3f1ef200&scoped=true&"
import script from "./ElderResidentsByNursingLevel.vue?vue&type=script&lang=js&"
export * from "./ElderResidentsByNursingLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ef200",
  null
  
)

export default component.exports